export const Base_Retainer_Request_Err = {
    id: 'retainer_request_prescription',
    valid: false,
    msg: 'Please fill in all required fields in Prescription Notes.',
};

export const Base_Prescription_Err = {
    id: 'prescriptionNotes',
    valid: true, // default true due to form has default value
    msg: 'Please fill in all required fields in Prescription Notes.',
};

export const Base_Smile_Design_Prescription_Err = {
    id: 'prescriptionNotesSD',
    valid: true, // default true, will set to false if user select add-on smile design and form is invalid
    msg: 'Please fill in all required fields in Smile Design Prescription Notes.',
};

export const buildSmileDesignPrescriptionErr = (isValid, getMsg) => ({
    id: Base_Smile_Design_Prescription_Err.id,
    msg: isValid ? '' : getMsg(),
    valid: isValid,
});

export const CASE_TYPE = {
    TOUCH_UP: 'TOUCH_UP',
    SIMPLE: 'SIMPLE',
    COMPLETE: 'COMPLETE',
    RETAINER: 'RETAINER',
    TOUCHUP_PLUS: 'TOUCHUP_PLUS',
    RECOMMEND: 'RECOMMEND',
    FLEX: 'FLEX',
    ULTRA: 'ULTRA',
    CHOOSE_LATER: 'CHOOSE_LATER',
    SELF_DESIGN: 'SELF_DESIGN',
};

export const ALIGNER_CASE_TYPE = [
    CASE_TYPE.FLEX,
    CASE_TYPE.SIMPLE,
    CASE_TYPE.TOUCH_UP,
    CASE_TYPE.TOUCHUP_PLUS,
    CASE_TYPE.ULTRA,
    CASE_TYPE.COMPLETE,
    CASE_TYPE.CHOOSE_LATER,
];

export const SELF_DESIGN_CASE_TYPE = [CASE_TYPE.SELF_DESIGN];

// refer to database case table 'case_status' column
export const CASE_STATUS = {
    DRAFT: 'DRAFT',
    SUBMITTED: 'SUBMITTED',
    DEFECT_UPLOADED: 'DEFECT_UPLOADED',
    DEFECT_RESPONDED: 'DEFECT_RESPONDED',
    AWAITING: 'AWAITING',
    RECEIVED: 'RECEIVED',
    PLAN_UPLOADED: 'PLAN_UPLOADED',
    CHANGE_REQUEST: 'CHANGE_REQUEST',
    PLAN_APPROVED: 'PLAN_APPROVED',
    PRODUCTION: 'PRODUCTION',
    DELIVERED: 'DELIVERED',
    NEXT_SET_REQUEST: 'NEXT_SET_REQUEST',
    ALL_DELIVERED: 'ALL_DELIVERED',
    ENDED: 'ENDED',
    REFINEMENT: 'REFINEMENT',
    DEFECT_RESUBMIT: 'DEFECT_RESUBMIT',
    RETRACK: 'RETRACK',
    RETRACK_END: 'RETRACK_END',
    RETRACK_REPORT: 'RETRACK_REPORT',
    RETRACK_PRODUCTION_IN_PROGRESS: 'RETRACK_PRODUCTION_IN_PROGRESS',
    RETRACK_CONTINUE: 'RETRACK_CONTINUE',
    RETRACK_DELIVERED: 'RETRACK_DELIVERED',
    RESTORATION_TOOL_FORM_SUBMITTED: 'RESTORATION_TOOL_FORM_SUBMITTED',
    UPGRADE_REQUEST: 'UPGRADE_REQUEST',
    RETRACK_AWAITING: 'RETRACK_AWAITING',
    RETRACK_ALL_MATERIAL_RECEIVED: 'RETRACK_ALL_MATERIAL_RECEIVED',
};
